export var StockStatus;
(function (StockStatus) {
    StockStatus["RESERVED"] = "RESERVED";
    StockStatus["SOLD_OUT"] = "SOLD_OUT";
    StockStatus["AVAILABLE"] = "AVAILABLE";
})(StockStatus || (StockStatus = {}));
//# sourceMappingURL=types.js.map